var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",attrs:{"to":'pardakht-shakhsi/'+_vm.row.id+'/details'}},[_c('i',{staticClass:"fa fa-eye"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }